import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { PageHeader } from './AuxiliaryFunctions';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import { useDispatch, } from "react-redux";
import { logout } from "./actions/auth.js";
import { changepsw } from "./actions/auth.js";
import { useSelector } from "react-redux";
import UserDataService from "./services/user.serviceaux.js";
import Sidebar from "./Sidebar";
import ExportSidebar from './ProSideBar.js';

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h3`
  margin-top: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

const Input = styled.input`
  padding: 0.6rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
`;


const Message = styled.p`
  color: green;
  margin-top: 1rem;
  text-align: center;
`;

const Profile = (props) => {
  const [profile, setProfile] = useState({});
  const { user: currentUser } = useSelector((state) => state.auth);	

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);

  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [segundonombre, setSegundoNombre] = useState('');
  const [segundoapellido, setSegundoApellido] = useState('');
  const [fechadenacimiento, setFechaDeNacimiento] = useState(null);
  const [telefonomovil, setTelefonoMovil] = useState(null);
  const [genero, setGenero] = useState('');
  const [curp, setCURP] = useState('');
  const [bio, setBio] = useState('');


  const dispatch = useDispatch();

  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [message, setMessage] = useState('');

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileSubmit = (e) => {
    e.preventDefault();
    UserDataService.update(currentUser.id, profile)
    .then(resp => {
      console.log(resp);
      setShowsuccess(true);
      setSuccmessage(resp.data.message);
      setShowerror(false);
      return;
    })
    .catch(err => {
      if (err.response.status === 401) {
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
       console.log(err.response);
      }
      setShowsuccess(false);
      setErrmessage(err.response.data.message);
      setShowerror(true);
      return;
    });



    //setMessage('Profile updated successfully!');
    // 🔁 Hook into your backend API here
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = passwords;
    if (newPassword !== confirmPassword) {
      setShowsuccess(false);
      setErrmessage('No coinciden las contraseñas!');
      setShowerror(true);
      return;
    }
    if (newPassword.length === 0) {
      setShowsuccess(false);
      setErrmessage('La nueva contraseña no puede ser vacía!');
      setShowerror(true);
      return;
    }    
    changePassword();
  };


  let changePassword = () => {
    console.log(currentUser);
    var data = {
      userid: currentUser.id,
      //userid: profile.id,
      currentpassword: passwords.currentPassword,
      newpassword: passwords.newPassword,
    }    
    dispatch(changepsw(data.userid, data.currentpassword, data.newpassword)) 
    .then((resp) => {
      console.log(resp);
      setShowerror(false);
      setSuccmessage('Tu contraseña ha sido actualizada!');
      setShowsuccess(true);
    })
    .catch((e) => {
      setShowsuccess(false);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);
    });     
  };

  useEffect(()=> {
    UserDataService.get(currentUser.id) 
    .then(resp => {
      //console.log(resp.data);
      let respdata = resp.data[0];
      respdata.roles = respdata.roles.map(rol => rol.id);
      console.log(respdata);
      setProfile(respdata);
    })
    .catch(err => {
      console.log(err);
    });
  }, [])

  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>      
      <ExportSidebar roles={currentUser.roles}/>
      <div style={{display:'block',width:'100%'}}>
        <Container style={{width:"80%"}}>
          <PageHeader />
          <Container>
            <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Mi perfil</h4>
          </Container>
          <Row>
          <div
            className="card card-container "
            style={{padding:'40px 40px',}}
          >
        
            <Form onSubmit={handleProfileSubmit}>
              <Label>Matrícula</Label>
              <Input
                disabled
                type="text"
                name="matrícula"
                value={profile.matricula}
                onChange={handleProfileChange}
              />                 

              <Label>Primer nombre</Label>
              <Input
                disabled
                type="text"
                name="firstName"
                value={profile.primernombre}
                onChange={handleProfileChange}
              />

              <Label>Segundo nombre</Label>
              <Input
                type="text"
                name="segundonombre"
                value={profile.segundonombre}
                onChange={handleProfileChange}
              />              

              <Label>Primer apellido</Label>
              <Input
                disabled
                type="text"
                name="lastName"
                value={profile.primerapellido}
                onChange={handleProfileChange}
              />

              <Label>Segundo apellido</Label>
              <Input
                type="text"
                name="segundoapellido"
                value={profile.segundoapellido}
                onChange={handleProfileChange}
              />                 

              <Label>Correo electrónico</Label>
              <Input
                disabled
                type="email"
                name="email"
                value={profile.email}
                onChange={handleProfileChange}
              />

              <Label>Bio</Label>
              <Input
                type="text"
                name="bio"
                value={profile.bio}
                onChange={handleProfileChange}
              />                 
              <Button className='btn btn-secondary' type="submit">Actualizar</Button>
            </Form>
          </div>


          <div
            className="card card-container "
            style={{maxWidth:'700px',padding:'40px 40px',}}>
            <Form onSubmit={handlePasswordSubmit}>
              <Label>Contraseña actual</Label>
              <Input
                type="password"
                name="currentPassword"
                value={passwords.currentPassword}
                onChange={handlePasswordChange}
              />

              <Label>Nueva contraseña</Label>
              <Input
                type="password"
                name="newPassword"
                value={passwords.newPassword}
                onChange={handlePasswordChange}
              />

              <Label>Confirmar contraseña</Label>
              <Input
                type="password"
                name="confirmPassword"
                value={passwords.confirmPassword}
                onChange={handlePasswordChange}
              />

              <Button className='btn btn-secondary' type="submit">Cambiar contraseña</Button>
            </Form>
          </div>
          </Row>
          <Row className='mt-2'>
          {showerror && (
            <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{errmessage}</p>
            </Alert>      
          )}
          {showsuccess && (
            <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
              <Alert.Heading>Hecho</Alert.Heading>
              <p>{succmessage}</p>
            </Alert>      
          )} 
          </Row>                  
        </Container>
      </div>
    </div>
    </>
  );
};

export default Profile;